/***************************************************************
01/18/2019
Alexander Self
Harvest Info Card
- Small info cards of different colors which provide important information
***************************************************************/
import React from 'react';

const IrrigationInfoCard = ({ header, label, icon, child, data, color, avg1, avg2 }) => {

  return (
    <div className="card-stats">
      <div className="card">
        <div className={`card-content ${color} white-text`}>
          <center>
            <span className="card-title text-darken-4"><i className="material-icons icon-shift">{icon}</i>{header}</span>
            <h4>{ data }</h4>
            { avg1 }
            { avg2 }
          </center>
        </div>
        <div className={`card-action ${color} darken-4`}>
          {child}
        </div>
      </div>
    </div>
  )
}

export default IrrigationInfoCard;







































/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/view/harvest_info_card.jsx